import { FilterExprSchema } from '@hostingportal/schemas'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import '../../../modules/companies/register-panels'
import { OrdersView } from '../../../modules/commerce/orders-view'
import '../../../modules/commerce/register-panels'
import { PANEL_TYPES } from '../../../shell/panel-state'

const ordersSearchSchema = z.object({
  q: z.string().optional(),
  sortField: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  filter: FilterExprSchema.optional(),
  quick: FilterExprSchema.optional(),
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
  panelMode: z.enum(['create']).optional(),
  pstack: z.string().optional(),
})

export const Route = createFileRoute('/_authed/orders/')({
  validateSearch: ordersSearchSchema,
  component: OrdersRoute,
})

function OrdersRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <OrdersView
      search={search}
      setSearch={(patch) =>
        navigate({
          to: '.',
          search: ((prev: Record<string, unknown>) => {
            const next: Record<string, unknown> = { ...prev, ...patch }
            for (const [key, value] of Object.entries(next)) {
              if (value == null || value === '') delete next[key]
            }
            return next
          }) as never,
          replace: true,
        })
      }
    />
  )
}
